import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';

const MESES = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
const MESES_LONGO = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

const parse = (v) => {
  const hoje = new Date();
  if (!v) return { ano: hoje.getFullYear(), mes: hoje.getMonth() + 1 };
  const [a, m] = v.split('-').map(Number);
  return { ano: a, mes: m };
};
const format = (ano, mes) => `${ano}-${String(mes).padStart(2, '0')}`;

// Substitui o `<input type="month">` nativo (§6 da evolução de produto —
// "não quero o popup nativo do navegador"). Setas ‹mês› pra navegação
// rápida (1 clique), clique no rótulo abre um grid ano/mês próprio do
// design system. Value/onChange no mesmo formato "YYYY-MM" de sempre —
// troca é só de componente, não de contrato de dado.
export function MonthPicker({ value, onChange, minWidth = 150 }) {
  const [open, setOpen] = useState(false);
  const { ano, mes } = parse(value);
  const [anoGrid, setAnoGrid] = useState(ano);
  const ref = useRef(null);

  useEffect(() => { if (open) setAnoGrid(ano); }, [open, ano]);

  useEffect(() => {
    const onClickOutside = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const mudarMes = (delta) => {
    const d = new Date(ano, mes - 1 + delta, 1);
    onChange(format(d.getFullYear(), d.getMonth() + 1));
  };
  const irParaHoje = () => {
    const hoje = new Date();
    onChange(format(hoje.getFullYear(), hoje.getMonth() + 1));
    setOpen(false);
  };

  return (
    <div className="crm-monthpicker" ref={ref} style={{ minWidth }}>
      <button type="button" className="crm-icon-btn" style={{ width: 24, height: 24 }} onClick={() => mudarMes(-1)} aria-label="Mês anterior">
        <FontAwesomeIcon icon={faChevronLeft} size="xs" />
      </button>
      <button type="button" className="crm-monthpicker-label" onClick={() => setOpen((v) => !v)} style={{ textTransform: 'capitalize' }}>
        {MESES_LONGO[mes - 1]} {ano}
      </button>
      <button type="button" className="crm-icon-btn" style={{ width: 24, height: 24 }} onClick={() => mudarMes(1)} aria-label="Próximo mês">
        <FontAwesomeIcon icon={faChevronRight} size="xs" />
      </button>
      {open && (
        <div className="crm-monthpicker-popup">
          <div className="crm-monthpicker-popup-header">
            <button type="button" className="crm-icon-btn" style={{ width: 24, height: 24 }} onClick={() => setAnoGrid((a) => a - 1)} aria-label="Ano anterior">
              <FontAwesomeIcon icon={faChevronLeft} size="xs" />
            </button>
            <span>{anoGrid}</span>
            <button type="button" className="crm-icon-btn" style={{ width: 24, height: 24 }} onClick={() => setAnoGrid((a) => a + 1)} aria-label="Próximo ano">
              <FontAwesomeIcon icon={faChevronRight} size="xs" />
            </button>
          </div>
          <div className="crm-monthpicker-grid">
            {MESES.map((m, i) => (
              <button
                key={m}
                type="button"
                className={`crm-monthpicker-cell${ano === anoGrid && mes === i + 1 ? ' active' : ''}`}
                onClick={() => { onChange(format(anoGrid, i + 1)); setOpen(false); }}
              >
                {m}
              </button>
            ))}
          </div>
          <button type="button" className="crm-dropdown-item" style={{ textAlign: 'center', justifyContent: 'center' }} onClick={irParaHoje}>Este mês</button>
        </div>
      )}
    </div>
  );
}

export default MonthPicker;
